export const LISTING_OCCUPANT_TYPE_OWNER = 'Owner';
export const LISTING_OCCUPANT_TYPE_VACANT = 'Vacant';
export const LISTING_OCCUPANT_TYPE_TENANT = 'Tenant';
export const LISTING_OCCUPANT_TYPE_OCCUPIED = 'Occupied';

export const LISTING_OCCUPANT_TYPES = [
  LISTING_OCCUPANT_TYPE_VACANT,
  LISTING_OCCUPANT_TYPE_OWNER,
  LISTING_OCCUPANT_TYPE_TENANT,
];

export const SUNRISE_LISTING_OCCUPANT_TYPES = [
  LISTING_OCCUPANT_TYPE_VACANT,
  LISTING_OCCUPANT_TYPE_OCCUPIED,
];

export const LISTING_STATUS_ACTIVE = 'Active';
export const LISTING_STATUS_LEASED = 'Leased/Rented';
export const LISTING_STATUS_NEEDS_REVIEW = 'Needs Review';
// TODO ---> export const LISTING_STATUS_INCOMPLETE = 'Incomplete';
// TODO: Add RealSavvy listing status constants.
export const LISTING_STATUS_NOT_AVAILABLE = 'N/A';
export const LISTING_STATUS_PENDING = 'Pending';
export const LISTING_STATUS_SOLD = 'Sold';
export const LISTING_STATUS_ARCHIVED = 'Archived';
export const LISTING_STATUS_WITHDRAWN = 'Withdrawn';

export const LISTING_STATUS_LIST = [
  LISTING_STATUS_ACTIVE,
  LISTING_STATUS_LEASED,
  LISTING_STATUS_NOT_AVAILABLE,
  LISTING_STATUS_PENDING,
  LISTING_STATUS_NEEDS_REVIEW,
];

export const LISTING_ACTIVE_STATUS_LIST = [
  LISTING_STATUS_ACTIVE,
  LISTING_STATUS_NEEDS_REVIEW,
  LISTING_STATUS_PENDING,
];

export const LISTING_ACTIVE_STATUS_FOR_RENTER = [LISTING_STATUS_ACTIVE, LISTING_STATUS_PENDING];

export const LISTING_ACTIVE_STATUS_FOR_TOUR_HEALTH = [
  LISTING_STATUS_ACTIVE,
  LISTING_STATUS_PENDING,
];

export const LISTING_MLS_STATUS_ACTIVE = 'Active';
export const LISTING_MLS_STATUS_ACTIVE_CONTINGENT = 'ActiveContingent';
export const LISTING_MLS_STATUS_INCOMPLETE = 'Incomplete';
export const LISTING_MLS_STATUS_LEASED = 'Leased';
export const LISTING_MLS_STATUS_NOT_AVAILABLE = 'N/A';
export const LISTING_MLS_STATUS_PENDING = 'Pending';
export const LISTING_MLS_STATUS_PENDING_TAKING_BACKUPS = 'PendingTakingBackups';
export const LISTING_MLS_STATUS_TEMPORARILY_OFF_MARKET = 'TemporarilyOffMarket';
export const LISTING_MLS_STATUS_WITHDRAWN = 'Withdrawn';

export const LISTING_DISPLAY_TYPE_SINGLE_UNIT = 'singleUnit';
export const LISTING_DISPLAY_TYPE_MULTI_UNIT = 'multiUnit';

export const LISTING_TYPE_RESIDENTIAL = 'Residential';

export const LISTING_MLS_STATUS_LIST = [
  LISTING_MLS_STATUS_ACTIVE,
  LISTING_MLS_STATUS_ACTIVE_CONTINGENT,
  LISTING_MLS_STATUS_INCOMPLETE,
  LISTING_MLS_STATUS_LEASED,
  LISTING_MLS_STATUS_NOT_AVAILABLE,
  LISTING_MLS_STATUS_PENDING,
  LISTING_MLS_STATUS_PENDING_TAKING_BACKUPS,
  LISTING_MLS_STATUS_TEMPORARILY_OFF_MARKET,
  LISTING_MLS_STATUS_WITHDRAWN,
];

export const LISTING_REALSAVVY_MLS_STATUS_TO_SUNROOM_MLS_STATUS = {
  Active: LISTING_MLS_STATUS_ACTIVE,
  'Active Kick Out': LISTING_MLS_STATUS_ACTIVE,
  'Active Option Contract': LISTING_MLS_STATUS_ACTIVE,
  ActiveUnderContract: LISTING_MLS_STATUS_ACTIVE_CONTINGENT,
  'Active Contingent': LISTING_MLS_STATUS_ACTIVE_CONTINGENT,
  Leased: LISTING_MLS_STATUS_LEASED,
  'N/A': LISTING_MLS_STATUS_NOT_AVAILABLE,
  Closed: LISTING_MLS_STATUS_NOT_AVAILABLE,
  Hold: LISTING_MLS_STATUS_PENDING,
  Pending: LISTING_MLS_STATUS_PENDING,
  'Pending - Over 4 Months': LISTING_MLS_STATUS_PENDING,
  'Pending - Taking Backups': LISTING_MLS_STATUS_PENDING_TAKING_BACKUPS,
  pendingUpdate: LISTING_MLS_STATUS_NOT_AVAILABLE,
  Sold: LISTING_MLS_STATUS_NOT_AVAILABLE,
  Withdrawn: LISTING_MLS_STATUS_WITHDRAWN,
  Expired: LISTING_MLS_STATUS_NOT_AVAILABLE,
};

export const LISTING_DATA_SOURCE_REALSAVVY = 'RealSavvy';
export const LISTING_DATA_SOURCE_SMART_APARTMENT = 'SmartApartment';
export const LISTING_DATA_SOURCE_SUNROOM = 'Sunroom';

export const LISTING_SR_BROKERAGE_MLS_NUMBER = '700353';
export const LISTING_SR_BROKERAGE_NAME = 'Sunroom Rentals Texas, LLC';

export const LISTING_LOCKBOX_TYPE_LOCKBOX = 'Electronic';
export const LISTING_LOCKBOX_TYPE_COMBO_LOCKBOX = 'Combo Lockbox';
export const LISTING_LOCKBOX_TYPE_BOTH = 'Both';
export const LISTING_LOCKBOX_TYPE_SEE_AGENT = 'See Agent';

export const LISTING_LOCKBOX_TYPES = [
  LISTING_LOCKBOX_TYPE_LOCKBOX,
  LISTING_LOCKBOX_TYPE_COMBO_LOCKBOX,
  LISTING_LOCKBOX_TYPE_BOTH,
  LISTING_LOCKBOX_TYPE_SEE_AGENT,
];

export const LISTING_LOCKBOX_LOCATION_GATE = 'Gate';
export const LISTING_LOCKBOX_LOCATION_FRONT_DOOR = 'Door-Front';
export const LISTING_LOCKBOX_LOCATION_SIDE_DOOR = 'Door-Side';
export const LISTING_LOCKBOX_LOCATION_BACK_DOOR = 'Door-Back';
export const LISTING_LOCKBOX_LOCATION_GARAGE_DOOR = 'Garage Door';
export const LISTING_LOCKBOX_LOCATION_STAIR_RAIL = 'Stair Rail';
export const LISTING_LOCKBOX_LOCATION_UTILITY_METER = 'Utility Meter';
export const LISTING_LOCKBOX_LOCATION_WATER_SPIGOT = 'Water Spigot';
export const LISTING_LOCKBOX_LOCATION_FENCE = 'Fence';
export const LISTING_LOCKBOX_LOCATION_PORCH = 'Porch';
export const LISTING_LOCKBOX_LOCATION_TREE = 'Tree';

export const LISTING_LOCKBOX_LOCATIONS = [
  LISTING_LOCKBOX_LOCATION_GATE,
  LISTING_LOCKBOX_LOCATION_FRONT_DOOR,
  LISTING_LOCKBOX_LOCATION_SIDE_DOOR,
  LISTING_LOCKBOX_LOCATION_BACK_DOOR,
  LISTING_LOCKBOX_LOCATION_GARAGE_DOOR,
  LISTING_LOCKBOX_LOCATION_STAIR_RAIL,
  LISTING_LOCKBOX_LOCATION_UTILITY_METER,
  LISTING_LOCKBOX_LOCATION_WATER_SPIGOT,
  LISTING_LOCKBOX_LOCATION_FENCE,
  LISTING_LOCKBOX_LOCATION_PORCH,
  LISTING_LOCKBOX_LOCATION_TREE,
];

export const LISTING_MOVE_IN_DATE_WARNING_THRESHOLD = 15;
export const LISTING_MOVE_IN_DATE_EXTENDED_DAYS = 7;

export const LISTING_COMPENSATION_TYPE_PERCENTAGE = '%';
export const LISTING_COMPENSATION_TYPE_AMOUNT = '$';

export const LISTING_COMPENSATION_TYPES = [
  LISTING_COMPENSATION_TYPE_PERCENTAGE,
  LISTING_COMPENSATION_TYPE_AMOUNT,
];

export const LISTING_PHOTO_DIMENSION_CARD = '355x230:85';
export const LISTING_PHOTO_DIMENSION_THUMBNAIL = '50x50:92';

export const LISTING_PHOTO_DIMENSIONS = [
  LISTING_PHOTO_DIMENSION_CARD,
  LISTING_PHOTO_DIMENSION_THUMBNAIL,
];

export const LISTING_APPLICATION_POLICY_FIRST = 'FirstQualified';
export const LISTING_APPLICATION_POLICY_BEST = 'BestQualified';

export const LISTING_PHONE_CONTACT_SUPPORT_SUNLOCK_ISSUE = '5125484192';
export const LISTING_PHONE_CONTACT_SUPPORT_LEASING_OPS = '5123615658';
export const LISTING_PHONE_CONTACT_SUPPORT_FIELD_OPS = '5129570512';

export const LISTING_DEFAULT_COUNT_BY_MAP_REQUEST = 100;
export const LISTING_MAX_DISTANCE_WITH_USER_IN_KM = 0.6096;
export const LISTING_MAX_PRICE_TO_REQUEST_ONLINE_APP = 1800;

export const LISTING_LIST_SPECIFIC_APARTMENTS = 'specificApartments';

export const LISTING_WHO_COLLECTS_LISTING_FEES_VALUE_SUNROOM = 'Sunroom';
export const LISTING_WHO_COLLECTS_LISTING_FEES_VALUE_MANUAL = 'Manual';

export const LISTING_CMA_DISCUSSION_PLACEHOLDER_URL_IMAGE =
  '/images/listing/image-cma-discussion.jpeg';
export const LISTING_IMAGE_PLACEHOLDER_URL = '/images/listing/image-placeholder.jpeg';
export const LISTING_IMAGE_PLACEHOLDER_URL_LARGE = '/images/listing/image-placeholder-large.jpeg';
export const LISTING_IMAGE_ARCHIVED_PLACEHOLDER_URL_LARGE =
  '/images/listing/image-archived-placeholder-large.jpeg';
export const LISTING_IMAGE_PRE_LEASE_COMING_PHOTOS_URL = '/images/photos-coming-soon.png';

export const LISTING_CMA_PRICE_PERCENTAGE = 1.025;
export const LISTING_CMA_DISCUSSION_NOT_DISCUSSED = 'NOT_DISCUSSED';
export const LISTING_CMA_DISCUSSION_ACKNOWLEDGED = 'ACKNOWLEDGED';
export const LISTING_CMA_DISCUSSION_AGREED = 'AGREED';
export const LISTING_CMA_DISCUSSION_VALUES = [
  LISTING_CMA_DISCUSSION_NOT_DISCUSSED,
  LISTING_CMA_DISCUSSION_ACKNOWLEDGED,
  LISTING_CMA_DISCUSSION_AGREED,
];

export const LISTING_AMENITIES_SETTINGS = {
  hasCommonFacilitiesWasherDryer: {
    emoji: '👚🏢',
    title: 'wash/dry in building',
    rentlinxAmenityId: 74,
  },
  hasWasherDryer: {
    emoji: '👚👕',
    title: 'wash/dry included',
    rentlinxAmenityId: [33, 34],
    zillowModelAmenities: ['Washer', 'Dryer'],
  },
  hasStackedWasherDryer: {
    emoji: '👚👕',
    title: 'stacked wash/dry included',
    rentlinxAmenityId: [33, 34],
    zillowModelAmenities: ['Washer', 'Dryer'],
  },
  hasWasher: {
    emoji: '👚👕',
    title: 'washer included',
    rentlinxAmenityId: 33,
    zillowModelAmenities: 'Washer',
  },
  hasDryer: {
    emoji: '👚👕',
    title: 'Dryer included',
    rentlinxAmenityId: 34,
    zillowModelAmenities: 'Dryer',
  },
  hasWasherDryerConnections: {
    emoji: '👚🔌',
    title: 'wash/dry connections',
    rentlinxAmenityId: 34,
  },
  hasCommunalWasherDryer: {
    emoji: '👚🏢',
    title: 'communal wash/dry',
    rentlinxAmenityId: 74,
  },
  hasShowerTub: {
    emoji: '🛁',
    title: 'Shower Tub',
    rentlinxAmenityId: null,
  },
  petsAllowed: {
    iconClassName: '',
    title: 'Cats & Dogs',
    rentlinxAmenityId: [10, 11],
  },
  catAllowed: {
    iconClassName: '',
    title: 'Cats Allowed',
    rentlinxAmenityId: 11,
  },
  dogsAllowed: {
    iconClassName: '',
    title: 'Dogs Allowed',
    rentlinxAmenityId: 10,
  },
  noPets: {
    iconClassName: '',
    title: 'Not Allowed',
    rentlinxAmenityId: [12, 13, 14],
  },
  hasYard: {
    iconClassName: 'hasYard',
    title: 'Yard',
    rentlinxAmenityId: null,
  },
  hasWoodFlooring: {
    iconClassName: 'hasWoodFlooring',
    title: 'Wood Floors',
    rentlinxAmenityId: null,
  },
  hasTileFlooring: {
    iconClassName: 'flooringTile',
    title: 'Tile Floors',
    rentlinxAmenityId: null,
  },
  hasCarpetFlooring: {
    iconClassName: 'flooringCarpet',
    title: 'Carpet Floors',
    rentlinxAmenityId: null,
  },
  noCarpet: {
    iconClassName: '',
    title: 'No Carpet',
    rentlinxAmenityId: null,
  },
  hasConcreteFlooring: {
    iconClassName: 'flooringConcrete',
    title: 'Concrete Floors',
    rentlinxAmenityId: null,
  },
  hasVinylFlooring: {
    iconClassName: 'flooringVinyl',
    title: 'Vinyl Floors',
    rentlinxAmenityId: null,
  },
  hasPool: {
    emoji: '🏊‍♀️',
    title: 'Pool',
    rentlinxAmenityId: 41,
    zillowPropertyAmenities: 'Pool',
  },
  hasGarage: {
    iconClassName: 'hasGarage',
    title: 'Garage',
    rentlinxAmenityId: 69,
  },
  hasFence: {
    iconClassName: 'fence',
    title: 'Fenced',
    rentlinxAmenityId: null,
  },
  hasFencedYards: {
    iconClassName: 'fence',
    title: 'Fenced in backyard',
    rentlinxAmenityId: null,
  },
  hasAccessGates: {
    iconClassName: 'gated',
    title: 'Gated Access',
    rentlinxAmenityId: null,
  },
  hasFitnessCenter: {
    emoji: '🏋️‍♂️',
    title: 'Exercise Facility',
    rentlinxAmenityId: 42,
    zillowPropertyAmenities: 'FitnessCenter',
  },
  isHandicapFriendly: {
    emoji: '♿️',
    title: 'Accessible',
    rentlinxAmenityId: 63,
    zillowPropertyAmenities: 'DisabledAccess',
  },
  hasHotTubSpaJacuzzi: {
    emoji: '🛀',
    title: 'Spa/Jacuzzi',
    rentlinxAmenityId: null,
  },
  hasJoggingTrail: {
    emoji: '🏃🏻‍♀️',
    title: 'Jogging Trail',
    rentlinxAmenityId: null,
  },
  parkingSpaces: {
    emoji: '🚗',
    title: 'Space',
    rentlinxAmenityId: 38,
  },
  hasDogWalkPark: {
    emoji: '🏞',
    title: 'Dog Park',
    rentlinxAmenityId: null,
  },
  hasStainlessSteelAppliances: {
    iconClassName: 'stainlessSteel', // TODO
    title: 'Stain. Steel',
    rentlinxAmenityId: null,
  },
  hasGasStove: {
    emoji: '🔥',
    title: 'Gas Stove',
    rentlinxAmenityId: null,
  },
  hasElectricStove: {
    emoji: '⚡️',
    title: 'Electric Stove',
    rentlinxAmenityId: null,
  },
  hasRefrigerator: {
    iconClassName: 'fridge',
    title: 'Fridge',
    rentlinxAmenityId: 29,
    zillowModelAmenities: 'Refrigerator',
  },
  electricityIncluded: {
    iconClassName: '',
    title: 'Electricity Included',
    rentlinxAmenityId: 3,
  },
  gasIncluded: {
    iconClassName: '',
    title: 'Gas Included',
    rentlinxAmenityId: 5,
  },
  heatIncluded: {
    iconClassName: '',
    title: 'Heat Included',
  },
  hasCentralHeating: {
    emoji: '🌡️',
    title: 'Central Heat',
  },
  hasNaturalGasHeating: {
    iconClassName: '',
    title: 'Natural Gas Heating',
  },
  hasRadiatorHeating: {
    iconClassName: '',
    title: 'Radiator Heating',
  },
  waterIncluded: {
    iconClassName: '',
    title: 'Water Included',
    rentlinxAmenityId: 7,
  },
  trashPickUpIncluded: {
    iconClassName: '',
    title: 'Trash Pick-up Included',
    rentlinxAmenityId: 68,
  },
  elevatorInBuilding: {
    iconClassName: '',
    title: 'Elevator in Building',
    rentlinxAmenityId: 49,
    zillowPropertyAmenities: 'Elevator',
  },
  hasBasement: {
    iconClassName: '',
    title: 'Basement',
    rentlinxAmenityId: 66,
    zillowPropertyAmenities: 'Basement',
  },
  hasPatio: {
    iconClassName: 'hasPatio',
    title: 'Patio',
    rentlinxAmenityId: 71,
    zillowPropertyAmenities: 'Patio',
  },
  hasBalcony: {
    iconClassName: 'hasBalcony',
    title: 'Balcony',
    rentlinxAmenityId: 72,
    zillowPropertyAmenities: 'Balcony',
  },
  hasDeck: {
    iconClassName: 'hasDeck',
    title: 'Deck',
    rentlinxAmenityId: 73,
    zillowPropertyAmenities: 'Deck',
  },
  isFurnished: {
    iconClassName: '',
    title: 'Furnished',
    rentlinxAmenityId: 36,
  },
  isNotFurnished: {
    iconClassName: '',
    title: 'Unfurnished',
    rentlinxAmenityId: 37,
  },
  smokeFree: {
    iconClassName: '',
    title: 'Smoke Free',
    rentlinxAmenityId: 64,
  },
  monthToMonthLeaseTerm: {
    iconClassName: '',
    title: 'Month to Month',
    rentlinxAmenityId: 16,
  },
  rentToOwnLeaseTerm: {
    iconClassName: '',
    title: 'Rent-to-Own',
    rentlinxAmenityId: 65,
  },
  highSpeedInternetIncluded: {
    iconClassName: '',
    title: 'High-Speed Internet Included',
    rentlinxAmenityId: 43,
  },
  highSpeedInternetAvailable: {
    iconClassName: '',
    title: 'High-Speed Internet Available',
    rentlinxAmenityId: 44,
  },
  hasRampedEntry: {
    iconClassName: '',
    title: 'No-Step or Ramped Entry',
    rentlinxAmenityId: 50,
  },
  hasAccessibleParking: {
    iconClassName: '',
    title: 'Accessible Parking',
    rentlinxAmenityId: 51,
  },
  hasLevelStyleDoorHandles: {
    iconClassName: '',
    title: 'Lever Style Door Handles',
    rentlinxAmenityId: 54,
  },
  environmentalControlsAboveFloor: {
    iconClassName: '',
    title: 'Environmental Controls 15"-48" Above Floor',
    rentlinxAmenityId: 55,
  },
  grabBarsInBathroom: {
    iconClassName: '',
    title: 'Grab Bars in Bathroom',
    rentlinxAmenityId: 56,
  },
  lowTresholdShower: {
    iconClassName: '',
    title: 'Low Threshold or Roll-In shower',
    rentlinxAmenityId: 57,
  },
  hasTTurnInBathroom: {
    iconClassName: '',
    title: "5' Turning Radius or T-Turn in Bathroom",
    rentlinxAmenityId: 58,
  },
  accessibleBathroomVanities: {
    iconClassName: '',
    title: 'Accessible Bathroom Vanities',
    rentlinxAmenityId: 59,
  },
  hasFrontLoadingKitchenAppliances: {
    iconClassName: '',
    title: 'Front Loading or Front Control Kitchen Appliances',
    rentlinxAmenityId: 60,
  },
  hasAccessibleKitchenCounters: {
    iconClassName: '',
    title: 'Accessible Kitchen Counters',
    rentlinxAmenityId: 61,
  },
  hasClearFloorAreaFrontOfSink: {
    iconClassName: '',
    title: 'Clear Floor Area in Front of Sink and Range',
    rentlinxAmenityId: 62,
  },
  has32WideDoorways: {
    iconClassName: '',
    title: '32" or Wider Doorways',
    rentlinxAmenityId: 52,
  },
  has36WideDoorways: {
    iconClassName: '',
    title: '36" or Wider Hallways',
    rentlinxAmenityId: 53,
  },
  hasAirConditioning: {
    iconClassName: 'hasAirConditioning',
    title: 'Air Conditioning',
    rentlinxAmenityId: 28,
  },
  hasCentralAc: {
    iconClassName: '',
    title: 'Central Air',
    rentlinxAmenityId: 28,
  },
  hasWalkInClosets: {
    emoji: '🚪',
    title: 'Walk-In Closets',
    rentlinxAmenityId: null,
  },
  hasExtraStorage: {
    iconClassName: 'hasExtraStorage',
    title: 'Extra Storage',
    rentlinxAmenityId: null,
  },
  hasDishWasher: {
    iconClassName: 'hasDishWasher',
    title: 'Dishwasher',
    rentlinxAmenityId: 26,
  },
  hasGarbageDisposal: {
    iconClassName: '',
    title: 'Garbage Disposal',
    rentlinxAmenityId: 32,
    zillowModelAmenities: 'GarbageDisposal',
  },
  hasMicrowave: {
    iconClassName: 'hasMicrowave',
    title: 'microwave',
    rentlinxAmenityId: 45,
    zillowModelAmenities: 'Microwave',
  },
  hasOven: {
    iconClassName: 'hasOven',
    title: 'Oven',
    rentlinxAmenityId: 31,
    zillowModelAmenities: 'RangeOven',
  },
  largeDogsAllowed: {
    iconClassName: '',
    title: 'Large Dogs Allowed',
    rentlinxAmenityId: 75,
    rentlinxAmenityOnFalse: true,
  },
  policyElectricPaid: {
    iconClassName: '',
    title: 'Owner Pays Electric',
    rentlinxAmenityId: 4,
    rentlinxAmenityOnFalse: true,
  },
  policyGasPaid: {
    iconClassName: '',
    title: 'Owner Pays Gas',
    rentlinxAmenityId: 6,
    rentlinxAmenityOnFalse: true,
  },
  policyWaterPaid: {
    iconClassName: '',
    title: 'Owner Pays Water',
    rentlinxAmenityId: 8,
    rentlinxAmenityOnFalse: true,
  },
  policyTrashPaid: {
    iconClassName: '',
    title: 'Owner Pays Trash',
    rentlinxAmenityId: 67,
    rentlinxAmenityOnFalse: true,
  },
  hasWaterSoftener: {
    emoji: '💧',
    title: 'Water Softener',
    rentlinxAmenityId: null,
  },
  hasWheelchairAccessible: {
    emoji: '♿',
    title: 'Wheelchair Accessible',
    rentlinxAmenityId: null,
  },
};

export const LISTING_AMENITIES_LIST = Object.keys(LISTING_AMENITIES_SETTINGS);

export const LISTING_AMENITIES_EXCLUDED_FROM_PUBLIC_API = [
  'monthToMonthLeaseTerm',
  'rentToOwnLeaseTerm',
  'noCarpet',
  'parkingSpaces',
];

export const LISTING_LINKS_TO_SCRAPE = [
  {
    siteName: 'MLS',
  },
  {
    siteName: 'Zillow',
    website: 'zillow.com',
  },
  {
    siteName: 'Trulia',
    website: 'trulia.com',
  },
  {
    siteName: 'Realtor.com',
    website: 'realtor.com',
  },
  {
    siteName: 'Zumper',
    website: 'zumper.com',
  },
  {
    siteName: 'Apartments.com',
    website: 'apartments.com',
  },
  {
    siteName: 'Apartment List',
    website: 'apartmentlist.com',
  },
  {
    siteName: 'HotPads',
    website: 'hotpads.com',
  },
];

export const PARTNER_LISTING_LINKS = LISTING_LINKS_TO_SCRAPE.filter(({ siteName }) => {
  return !['MLS'].includes(siteName);
});

export const LISTING_WALKTHROUGH_CONDITION_READY = 'LISTING_WALKTHROUGH_CONDITION_READY';
export const LISTING_WALKTHROUGH_CONDITION_NO_ELECTRICITY =
  'LISTING_WALKTHROUGH_CONDITION_NO_ELECTRICITY';
export const LISTING_WALKTHROUGH_CONDITION_OCCUPIED = 'LISTING_WALKTHROUGH_CONDITION_OCCUPIED';
export const LISTING_WALKTHROUGH_CONDITION_TOO_DIRTY = 'LISTING_WALKTHROUGH_CONDITION_TOO_DIRTY';
export const LISTING_WALKTHROUGH_CONDITION_COMBO_CODE_DOESNT_WORK =
  'LISTING_WALKTHROUGH_CONDITION_COMBO_CODE_DOESNT_WORK'; // eslint-disable-line max-len
export const LISTING_WALKTHROUGH_CONDITION_NO_COMBO_LOCK =
  'LISTING_WALKTHROUGH_CONDITION_NO_COMBO_LOCK';
export const LISTING_WALKTHROUGH_CONDITION_NO_KEY_IN_COMBO_LOCKBOX =
  'LISTING_WALKTHROUGH_CONDITION_NO_KEY_IN_COMBO_LOCKBOX'; // eslint-disable-line max-len
export const LISTING_WALKTHROUGH_CONDITION_OTHER = 'LISTING_WALKTHROUGH_CONDITION_OTHER';
export const LISTING_WALKTHROUGH_CONDITION_ITEMS = [
  {
    label: 'Yes',
    value: LISTING_WALKTHROUGH_CONDITION_READY,
  },
  {
    label: 'No: Electricity was not on.',
    value: LISTING_WALKTHROUGH_CONDITION_NO_ELECTRICITY,
  },
  {
    label: 'No: Space is currently occupied.',
    value: LISTING_WALKTHROUGH_CONDITION_OCCUPIED,
  },
  {
    label: 'No: The unit was dirty or not made-ready.',
    value: LISTING_WALKTHROUGH_CONDITION_TOO_DIRTY,
  },
  {
    label: "No: The combo code didn't work.",
    value: LISTING_WALKTHROUGH_CONDITION_COMBO_CODE_DOESNT_WORK,
  },
  {
    label: 'No: There was no combo lockbox.',
    value: LISTING_WALKTHROUGH_CONDITION_NO_COMBO_LOCK,
  },
  {
    label: 'No: There was no key in the lockbox.',
    value: LISTING_WALKTHROUGH_CONDITION_NO_KEY_IN_COMBO_LOCKBOX,
  },
  {
    label: 'No: Other',
    value: LISTING_WALKTHROUGH_CONDITION_OTHER,
  },
];
export const LISTING_WALKTHROUGH_CONDITION_TO_PUBLIC_API_TYPE = {
  [LISTING_WALKTHROUGH_CONDITION_NO_ELECTRICITY]: 'Electricity was not on.',
  [LISTING_WALKTHROUGH_CONDITION_OCCUPIED]: 'Space is currently occupied.',
  [LISTING_WALKTHROUGH_CONDITION_TOO_DIRTY]: 'The unit was dirty or not made-ready.',
  [LISTING_WALKTHROUGH_CONDITION_COMBO_CODE_DOESNT_WORK]: "The combo code didn't work.",
  [LISTING_WALKTHROUGH_CONDITION_NO_COMBO_LOCK]: 'There was no combo lockbox.',
  [LISTING_WALKTHROUGH_CONDITION_NO_KEY_IN_COMBO_LOCKBOX]: 'There was no key in the lockbox.',
  [LISTING_WALKTHROUGH_CONDITION_OTHER]: 'Other.',
};

export const LISTING_YARD_SIGN_REDIRECTION_UTM_QUERY_PARAMETERS =
  'utm_source=leasing&utm_medium=real-world&utm_campaign=self-tour&utm_content=yard-sign';

export const LISTING_SERVICE_TYPE_FULL_SERVICE = 'FullService';
export const LISTING_SERVICE_TYPE_TENANT_SCREENING = 'TenantScreening';
export const LISTING_SERVICE_TYPE_SUNRISE = 'SunRise';

export const LISTING_SERVICE_TYPES = [
  LISTING_SERVICE_TYPE_FULL_SERVICE,
  LISTING_SERVICE_TYPE_TENANT_SCREENING,
  LISTING_SERVICE_TYPE_SUNRISE,
];

export const LISTING_SERVICE_OPTION_ITEMS = [
  {
    label: 'Full-Service',
    value: LISTING_SERVICE_TYPE_FULL_SERVICE,
  },
  {
    label: 'SunScreen',
    value: LISTING_SERVICE_TYPE_TENANT_SCREENING,
  },
  {
    label: 'SunSetup',
    value: LISTING_SERVICE_TYPE_SUNRISE,
  },
];

export const LISTING_PRELEASE_TIME_WINDOW_IN_DAYS = 6;

export const LISTING_NOT_AVAILABLE_REASON_ACCIDENTALLY_MADE_ACTIVE = 'Accidentally made active';
export const LISTING_NOT_AVAILABLE_REASON_TEMPORARILY_OFF_MARKET = 'Temporarily Off Market';
export const LISTING_NOT_AVAILABLE_REASON_LISTING_GOT_WITHDRAWN = 'Listing got withdrawn';

export const LISTING_NOT_AVAILABLE_REASON_LIST = [
  LISTING_NOT_AVAILABLE_REASON_ACCIDENTALLY_MADE_ACTIVE,
  LISTING_NOT_AVAILABLE_REASON_TEMPORARILY_OFF_MARKET,
  LISTING_NOT_AVAILABLE_REASON_LISTING_GOT_WITHDRAWN,
];

export const LISTING_DEFAULT_MANAGEMENT_COMPANY_PHONE = '5126485324';

export const LISTING_MARKETING_DESCRIPTION_PREFIX =
  'Only tour, apply, pay deposit, and lease this home through Sunroom Rentals. Search for the address on Sunroom Rentals.'; // eslint-disable-line max-len

export const LISTING_AGREEMENT_CUSTOM = 'Custom';
export const LISTING_AGREEMENT_MANUAL = 'Manual';

export const LISTING_AGREEMENT_OPTION_ITEMS = [
  {
    label: 'Upload Listing Agreement',
    value: LISTING_AGREEMENT_CUSTOM,
  },
  {
    label: 'Enter leasing info manually',
    value: LISTING_AGREEMENT_MANUAL,
  },
];

export const LISTING_PROPERTY_OWNER_BUSINESS = 'Business';
export const LISTING_PROPERTY_OWNER_INSTITUTION = 'Institution';
export const LISTING_PROPERTY_OWNER_INDIVIDUAL = 'Individual';

export const LISTING_PROPERTY_OWNER_OPTION_ITEMS = [
  {
    label: LISTING_PROPERTY_OWNER_BUSINESS,
    value: LISTING_PROPERTY_OWNER_BUSINESS,
  },
  {
    label: LISTING_PROPERTY_OWNER_INDIVIDUAL,
    value: LISTING_PROPERTY_OWNER_INDIVIDUAL,
  },
];

export const LISTING_SUNRISE_PROPERTY_OWNER_OPTION_ITEMS = [
  {
    label: LISTING_PROPERTY_OWNER_INSTITUTION,
    value: LISTING_PROPERTY_OWNER_INSTITUTION,
  },
  {
    label: LISTING_PROPERTY_OWNER_INDIVIDUAL,
    value: LISTING_PROPERTY_OWNER_INDIVIDUAL,
  },
];

export const LISTING_VIRTUAL_3D_TOUR_COST = 250;
export const LISTING_ERROR_DUPLICATE_ADDRESS =
  'Whoops, it looks like you already submitted this address. It’s currently going to market or live on market. Please submit a new property.'; // eslint-disable-line max-len

export const DAYS_ON_MARKET_FILTER_1_30 = '1-30';
export const DAYS_ON_MARKET_FILTER_30_60 = '30-60';
export const DAYS_ON_MARKET_FILTER_60 = '60+';

export const DAYS_ON_MARKET_FILTER_MAPPING = {
  [DAYS_ON_MARKET_FILTER_1_30]: '<= 30',
  [DAYS_ON_MARKET_FILTER_30_60]: 'BETWEEN 31 AND 60',
  [DAYS_ON_MARKET_FILTER_60]: '> 60',
};
export const LISTING_WITHDRAWAL_REASON_LEASED = 'Leased';
export const LISTING_WITHDRAWAL_REASON_OWNER_SOLD_PROPERTY = 'OwnerSoldProperty';
export const LISTING_WITHDRAWAL_REASON_OWNER_NOT_INTERESTED = 'OwnerNotInterested';
export const LISTING_WITHDRAWAL_REASON_OTHER = 'Other';

export const LISTING_SUNSETUP_WITHDRAWAL_REASON_OPTION_ITEMS = [
  {
    label: 'Leased',
    value: LISTING_WITHDRAWAL_REASON_LEASED,
  },
  {
    label: 'Owner decided to sell the property',
    value: LISTING_WITHDRAWAL_REASON_OWNER_SOLD_PROPERTY,
  },
  {
    label: 'Owner does not want our leasing services anymore',
    value: LISTING_WITHDRAWAL_REASON_OWNER_NOT_INTERESTED,
  },
  {
    label: 'Other',
    value: LISTING_WITHDRAWAL_REASON_OTHER,
  },
];

export const LISTING_UTILITY_FIELD_TO_ZILLOW_UTILITY_MAPPING = {
  policyElectricPaid: 'Electricity',
  policyGasPaid: 'Gas',
  policyTrashPaid: 'Garbage',
  policyWaterPaid: 'Water',
  policyPestControlpaid: null,
  highSpeedInternetIncluded: 'Internet',
  policyGardeningPaid: null,
};
